const Permissions = Object.freeze({
    ADMIN: "admin",
    MANAGER: "manager",
    USER: "user",
});

export default Permissions;